import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {DashboardComponent} from './pages/dashboard/dashboard.component';

const routes: Routes = [{ path: '', component: DashboardComponent, data: { title: 'DASHBOARD_PAGE_TITLE' } }];

@NgModule({ imports: [RouterModule.forChild(routes)], exports: [RouterModule] })
export class DashboardRoutingModule {}
